import { render, staticRenderFns } from "./MizaPayment.vue?vue&type=template&id=28bf6ac3&"
import script from "./MizaPayment.vue?vue&type=script&lang=js&"
export * from "./MizaPayment.vue?vue&type=script&lang=js&"
import style0 from "./MizaPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports